import styled from 'styled-components'

export const DemandStyle = styled.div`
  margin: 40px 0 0 0;
  display: flex;
  padding: 20px 0;
  position: relative;
  .background-image {
    position: absolute;
    z-index: -1;
    width: 100%;
    display: block;
    left: 0;
    right: 0;
    bottom: -30px;
    top: -30px;
    > img {
      display: block;
      width: 100%;
      height: 600px;
    }
  }
  .scroll-row {
    .scroll-col {
      margin-bottom: 40px;
    }
  }
  .card-image-box {
    padding: 0;
    .title {
      margin-bottom: 31px;
    }
  }
  @media screen and (min-width: 300px) and (max-width: 768px) {
    .background-image {
      display: none;
    }
    .scroll-row {
      overflow-x: scroll;
      overflow-y: hidden;
      white-space: nowrap;
      display: block;
      -webkit-overflow-scrolling: touch;
      .scroll-col {
        height: 100%;
        flex-basis: 70%;
        max-width: 70%;
        margin-right: 15px;
        display: inline-flex;
        vertical-align: top;
        border-radius: 20px;
        margin-bottom: 0;
      }
    }
    .card-image-box {
      padding: 0;
      .title {
        margin-bottom: 16px;
        min-height: 48px;
      }
      .text {
        min-height: 280px;
      }
    }
  }
  .bottom-margin {
    margin-bottom: 20px;
  }
  .top-margin {
    margin-top: 20px;
  }
  .card-shadow {
    box-shadow: 0 8px 20px 0 rgba(113, 128, 246, 0.1);
  }
`
